// The site's sections beside the live streams and the videos: VR scenes, cartoon porn and hentai, each
// with its own page (/vr, /cartoon, /hentai) and left out of the video feeds. A video's section is
// videos.section, given on import or by its categories in the hourly recount (lib/catalog-upkeep.ts).

export const SECTIONS = ["vr", "cartoon", "hentai"] as const;
export type Section = (typeof SECTIONS)[number];

export const isSection = (v: unknown): v is Section => SECTIONS.includes(v as Section);

/** A section's page. */
export const sectionPath = (s: Section) => `/${s}`;

/**
 * The categories whose pages list a section's videos with the rest (every other category's page leaves
 * them out), and which link to the section's page.
 */
export const SECTION_TAGS: Record<Section, string[]> = {
  vr: ["virtual-reality", "180", "360"],
  cartoon: ["cartoon"],
  hentai: ["hentai", "futanari"],
};

/** The section a category's page links to, if any. */
export const sectionOfTag = (slug: string): Section | undefined => SECTIONS.find((s) => SECTION_TAGS[s].includes(slug));
